import type { Nullable } from 'corgi-types';

interface UseKeyboardNavigationProps {
  nextSlide: () => void;
  previousSlide: () => void;
  totalSlides: number;
  goToSlide: (index: number) => void;
  activeTabRef: React.RefObject<Nullable<HTMLButtonElement>>;
}

export const useCarouselKeyboardNavigation = ({
  nextSlide,
  previousSlide,
  totalSlides,
  goToSlide,
  activeTabRef,
}: UseKeyboardNavigationProps) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    const { key } = event;

    const keysNext = ['ArrowRight', 'Right'];
    const keysPrevious = ['ArrowLeft', 'Left'];
    let hasChangedSlide = false;
    if (keysNext.includes(key)) {
      hasChangedSlide = true;
      nextSlide();
    } else if (keysPrevious.includes(key)) {
      hasChangedSlide = true;
      previousSlide();
    } else if (key === 'Home') {
      hasChangedSlide = true;
      goToSlide(0);
    } else if (key === 'End') {
      hasChangedSlide = true;
      goToSlide(totalSlides - 1);
    }

    if (hasChangedSlide) {
      event.preventDefault();
      setTimeout(() => {
        activeTabRef.current?.focus();
      }, 0);
    }
  };

  return handleKeyDown;
};
